module.exports = __webpack_public_path__ + "img/arrow-up-fill.51142480.svg";